import apiClient from './apiClient';

export const productService = {
    // Get all products
    getAllProducts: async (params = {}) => {
        try {
            const response = await apiClient.get('/products', { params });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Get single product
    getProduct: async (id) => {
        try {
            const response = await apiClient.get(`/products/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Create new product
    createProduct: async (productData) => {
        try {
            const response = await apiClient.post('/products', productData);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Update product
    updateProduct: async (id, productData) => {
        try {
            const response = await apiClient.put(`/products/${id}`, productData);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Delete product
    deleteProduct: async (id) => {
        try {
            const response = await apiClient.delete(`/products/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Get product statistics
    getProductStats: async () => {
        try {
            const response = await apiClient.get('/products-data/stats');
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Per-zone price list for one package. Pass customerId to see the prices
    // that customer actually pays rather than list price.
    getTariff: async (id, customerId = null) => {
        try {
            const response = await apiClient.get(`/products/${id}/tariff`, {
                params: customerId ? { customer_id: customerId } : {},
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    }
}; 